import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Dotdotdot from 'react-dotdotdot';
import { FormattedMessage, injectIntl } from 'react-intl';
import styles from './styles/line-item.scss';
import CategoryBadge from '../product/category-badge';
import { getPhone } from '../../helper';

const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;

class LineItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quantity: this.props.lineItem.attributes.quantity,
        };

        this.destroyLineItem = this.destroyLineItem.bind(this);
        // this.onChangeQuantity = this.onChangeQuantity.bind(this);
        // this.triggerChange = this.triggerChange.bind(this);
        this.minus = this.minus.bind(this);
        this.plus = this.plus.bind(this);

        this.timer = null;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.quantity !== this.state.quantity) {
            this.handleCheck();
        }
    }

    onChangeQuantity = (e) => {
        if (parseInt(e.target.value, 10) < this.props.lineItem.attributes.top) {
            this.setState({
                // eslint-disable-next-line radix
                quantity: parseInt(e.target.value),
            });
        }
    };

    getCategory() {
        if (this.props.lineItem && this.props.lineItem.shipping_category
            && this.props.lineItem.shipping_category.name
            && this.props.lineItem.shipping_category.name !== 'Default'
        ) {
            return this.props.lineItem.shipping_category.name;
        }
        return null;
    }

    handleCheck = () => {
        // eslint-disable-next-line radix
        this.props.changeQuantity(this.props.lineItem.id, parseInt(this.state.quantity), this.props.currentZone, this.props.locale.currentLocale);
        // Clears running timer and starts a new one each time the user types
        // clearTimeout(this.timer);
        // this.timer = setTimeout(() => {
        //     // eslint-disable-next-line radix
        //     this.props.changeQuantity(this.props.lineItem.id, parseInt(this.state.quantity), this.props.locale.currentLocale);
        // }, WAIT_INTERVAL);
    };

    minus = () => {
        this.setState((prevState) => ({
            quantity: this.props.lineItem.attributes.quantity - 1,
        }));
        this.props.disablingPlus(false);
    };

    plus = () => {
        if (this.props.lineItem.attributes.top === null || this.props.lineItem.attributes.quantity < this.props.lineItem.attributes.top) {
            this.setState((prevState) => ({
                quantity: prevState.quantity + 1,
            }));
        }
        if (this.props.lineItem.attributes.quantity + 1 === this.props.lineItem.attributes.top) {
            this.props.disablingPlus(true);
        }
    };

    buildPhones = (data, types) => {
        if (types) {
            const phoneType = types.find(({ attributes }) => attributes.field_type === 'phone');
            const phoneData = data.filter(({ attributes }) => attributes.type_id === Number(phoneType.id));

            return phoneData.map(
                ({ id, attributes }) => (
                    <div className={styles.phoneRow} key={attributes.value}>
                        <span>{getPhone(attributes.value)}</span>
                        {
                            phoneData.length > 1
                                ? (
                                    <button
                                        type="button"
                                        disabled={this.props.order.removingProductToCart || this.props.order.addingProductToCart}
                                        className="cart-delete-button-small"
                                        onClick={() => this.props.destroyDataExtra(id, this.props.locale.currentLocale)}
                                    >
                                        <i className="pe-7f-trash" />
                                    </button>
                                )
                                : null
                        }
                    </div>
                ),
            );
        }

        return null;
    };

    destroyLineItem(lineItem) {
        if (this.props.lineItemsCount > 1) {
            this.props.destroyLineItem(lineItem, this.props.locale.currentLocale);
        } else {
            this.props.emptyCart(this.props.order, this.props.locale.currentLocale);
        }
    }

    render() {
        const discountPercent = (((this.props.lineItem.attributes.price - this.props.lineItem.attributes.discounted_amount) * 100) / this.props.lineItem.attributes.price);

        return (
            <div className="row card-horizontal-holder" key={this.props.productSlug}>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    {this.getCategory() && (<CategoryBadge label={this.getCategory()} color="#FE6902" expand />)}
                    <div className="row left">
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 image-product">
                            <Link
                                to={`/products/${this.props.productSlug}`}
                                className="cart-image-link"
                            >
                                <img
                                    className="cart-image"
                                    alt={this.props.lineItem.attributes.name}
                                    src={this.props.imageUrl}
                                />
                            </Link>
                            {discountPercent > 0 && (
                                <div className="discount">
                                    -
                                    {discountPercent}
                                    %
                                </div>
                            )}
                        </div>

                        <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8 info-product">
                            <div className="row product-name">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <Link to={`/products/${this.props.productSlug}`}>
                                        <h3>{this.props.lineItem.attributes.name}</h3>
                                    </Link>
                                    <div className={styles.phones}>{this.buildPhones(this.props.lineItem.data_extras, this.props.lineItem.data_extra_types)}</div>
                                </div>
                            </div>
                            <div className="row product-description">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <Dotdotdot clamp={4}>
                                        <p>
                                            {this.props.lineItem.attributes.description}
                                        </p>
                                    </Dotdotdot>
                                </div>

                            </div>
                            {/* {!this.props.lineItem.attributes.available && ( */}
                            {/*    <div className={`row ${styles.unavailableCont}`}> */}
                            {/*        <div className="text-danger col-lg-12 col-md-12 col-sm-12 col-xs-12"> */}
                            {/*            <FormattedMessage id="outofstock" default="Out of stock" /> */}
                            {/*        </div> */}
                            {/*    </div> */}
                            {/* )} */}
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div className="row">
                        <div
                            className="col-lg-offset-2 col-lg-3 col-md-offset-2 col-md-3 col-sm-offset-1 col-sm-3 col-xs-4"
                        >
                            <div className="cart-item-price-col">
                                {this.props.lineItem.attributes.display_price}
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-4">
                            <div className="quantity-prods">
                                <div className="selector-quantity">
                                    <button
                                        className="minus"
                                        type="button"
                                        onClick={this.minus}
                                        disabled={this.state.quantity === 1 || this.props.order.addingProductToCart
                                            || this.props.order.removingProductToCart || this.props.lineItem.data_extras.length !== 0
                                            || this.props.errorShipping
                                            ? 'disabled' : ''}
                                    >
                                        -
                                    </button>
                                    <div className="quantity-container">
                                        <input
                                            type="text"
                                            value={this.props.lineItem.attributes.quantity}
                                            name="quantity"
                                            className="qty-number cart-item-qty-input"
                                            autoComplete="off"
                                            readOnly
                                        />
                                    </div>
                                    <button
                                        className="plus"
                                        disabled={this.props.order.addingProductToCart || this.props.order.disablingAdd
                                            || !this.props.lineItem.attributes.available || this.props.order.removingProductToCart
                                            || this.props.lineItem.data_extras.length !== 0 || this.props.errorShipping}
                                        type="button"
                                        onClick={this.plus}
                                    >
                                        +
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-4">
                            <div className="cart-item-subtotal-col">
                                {this.props.lineItem.attributes.display_discounted_amount}
                            </div>
                        </div>
                        <div className="btn-action-holder">
                            <button
                                type="button"
                                disabled={this.props.order.removingProductToCart || this.props.order.addingProductToCart}
                                className="cart-delete-button"
                                onClick={() => this.destroyLineItem(this.props.lineItem)}
                            >
                                <i className="pe-7f-trash" />
                            </button>
                        </div>
                    </div>
                    {this.props.errorShipping && (
                        <div className="row shipping-address-problems-item-container">
                            <div className="shipping-address-problems-item">
                                <FormattedMessage
                                    id="shipping-address-problems-item"
                                    defaultMessage="Cannot be shipped to the select address."
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default injectIntl(LineItem);



/** WEBPACK FOOTER **
 ** ./src/components/cart/line-item.jsx
 **/